// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2mMty","alert":"SettungsInbox_alert__xUEpm"};